import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { useGlobal } from '../../../contexts/Global/context';

import Checkbox from '../Checkbox';

import * as Styles from '../styles';
import * as S from './styles';

function CheckboxGroup({ field, columns = 2, onChange, onBlur, ...rest }) {
    const { contrastTheme } = useGlobal();
    
    field.value = field?.value?.map((value) => value?.toString()) || [];
    field.options =
        field?.options.map(({ codigo, nome, ...restOptions }) => ({
            codigo: codigo?.toString(),
            nome,
            ...restOptions,
        })) || [];

    function handleClickOption({ codigo: value }) {
        const checkedValues = field.value.filter((fieldValue) => fieldValue !== value.toString());

        const valueWasChecked = field.value.includes(value?.toString());

        if (!valueWasChecked) {
            checkedValues.push(value.toString());
        }

        const lookupValues = checkedValues.map((checkedValue) =>
            field.options.find(({ codigo }) => codigo === checkedValue.toString())
        );

        return { id: field.id, value: [...checkedValues], lookup: [...lookupValues] };
    }

    function handleClick(event) {
        const dataChange = handleClickOption(event);

        if (typeof onChange === 'function') onChange(dataChange);
    }

    return (
        <Styles.FormGroup>
            <label htmlFor="first-checkbox">
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
            </label>

            <S.ContainerCheckbox className="input-checkbox_group" columns={columns}>
                {field.options.map((option) => {
                    const isChecked = field.value.includes(option.codigo?.toString());

                    return (
                        <FormControlLabel
                            key={`${field.id}-${option.codigo}`}
                            value={option.codigo}
                            label={<S.FormControlText> {option.nome} </S.FormControlText>}
                            checked={isChecked}
                            onClick={() =>
                                !option.disabled && !field.disabled ? handleClick({ ...option }) : () => {}
                            }
                            control={
                                <Checkbox
                                    disabled={option.disabled || field.disabled}
                                    error={field.error}
                                    checked={isChecked}
                                    contrastTheme={contrastTheme}
                                />
                            }
                            {...rest}
                        />
                    );
                })}
            </S.ContainerCheckbox>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default CheckboxGroup;
